import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';
import useUser from 'Utilities/hooks/useUser';

const MOBILIZE_PARTNER = 'mobilize';

export const useIsMobilizeMarketplaceVisible = (): boolean => {
	const flagOn = useFeatureToggle(FEATURES.mobilizeMarketplaceVisibility);
	const user = useUser();
	const isMobilizePartner =
		user.partners?.some((partner: string) => partner.toLowerCase() === MOBILIZE_PARTNER) ?? false;

	return flagOn && isMobilizePartner;
};
